import React from 'react';
import { epochToDateStringWithYear } from '../../../helper';

import './Post.css';

function Post({ homeData }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {homeData?.data?.map((item, itemIndex) => {
        const isFistBriefing = itemIndex === 0;
        return (
          <div
            key={item.id}
            style={{
              marginTop: isFistBriefing ? 0 : 40,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div className='date'>
              {epochToDateStringWithYear(item.createdAt._seconds)}
            </div>
            {item?.stories?.map((story) => {
              return (
                <div className='story-container' key={story.id}>
                  <div
                    className='title'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <span className='title-heading'>{story.heading}</span>
                  </div>
                  <div
                    className='post-story-description'
                    dangerouslySetInnerHTML={{ __html: story.content }}
                  />
                </div>
              );
            })}
            <img
              alt='seprator'
              src='/assets/tilde-seprator.png'
              style={{
                height: '50px',
                width: '100px',
                objectFit: 'contain',
                display: 'flex',
                alignSelf: 'center',
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default Post;
